import { render, staticRenderFns } from "./businessNotification.vue?vue&type=template&id=7be853d0&scoped=true"
import script from "./businessNotification.vue?vue&type=script&lang=js"
export * from "./businessNotification.vue?vue&type=script&lang=js"
import style0 from "./businessNotification.vue?vue&type=style&index=0&id=7be853d0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7be853d0",
  null
  
)

export default component.exports